import { generateRandomID } from "./generateRandomID"
import { orderArrayV2 } from "./orderArray"

export const addLabelArray = (arr, label = '', label2 = '') => {
  const labels = [label, label2]
  try {
    const newArr = arr.map(item => {
      return {
        ...item,
        value: item?.id ? item.id : typeof item === 'string' ? item : generateRandomID(4),
        // label: label.length > 0 ? item[labels[0]] : label2.length > 0 ? `${item[labels[0]] - item[labels[1]]}` : item
        label: label.length > 0 && label2.length > 0 ? `${item[labels[0]]} - ${item[labels[1]]}` : item[labels[0]] ? item[labels[0]] : item[labels[1]] ? item[labels[1]] : item
      }
    })
    const ordered = orderArrayV2(newArr, label)
    return ordered
  } catch (error) {
    console.error(`Error al crear las etiquetas`)
  }
}